<template>
    <div>
        <div>
            <div class="flex justify-between">
                <label for="phone" class="block text-sm font-medium text-gray-700">Имя</label>
            </div>
            <div class="mt-1">
                <input v-model="fields.firstName" type="text" name="first_name" id="phone"
                       class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                       placeholder=""/>
            </div>
        </div>
        <div class="mt-2">
            <div class="flex justify-between">
                <label for="body" class="block text-sm font-medium text-gray-700">Фамилия</label>
            </div>
            <div class="mt-1">
                <input v-model="fields.lastName" type="text" name="lastName" id="body"
                       class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                       placeholder=""/>
            </div>
        </div>
        <div class="mt-2">
            <div class="flex justify-between">
                <label for="body" class="block text-sm font-medium text-gray-700">Телефон</label>
            </div>
            <div class="mt-1">
                <input v-model="fields.phone" type="text" name="phone" id="body"
                          class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                          placeholder=""/>
            </div>
        </div>
        <div class="mt-2">
            <div class="flex justify-between">
                <label for="body" class="block text-sm font-medium text-gray-700">Email</label>
            </div>
            <div class="mt-1">
                <input v-model="fields.email" type="text" name="email" id="body"
                          class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                          placeholder=""/>
            </div>
        </div>
        <div class="mt-2">
            <div class="flex justify-between">
                <label for="body" class="block text-sm font-medium text-gray-700">Страна</label>
            </div>
            <div class="mt-1">
                <input v-model="fields.country" type="text" name="country" id="body"
                          class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                          placeholder=""/>
            </div>
        </div>
        <div class="mt-2">
            <div class="flex justify-between">
                <label for="body" class="block text-sm font-medium text-gray-700">Город</label>
            </div>
            <div class="mt-1">
                <input v-model="fields.city" type="text" name="city" id="body"
                          class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                          placeholder=""/>
            </div>
        </div>
        <div class="mt-2">
            <div class="flex justify-between">
                <label for="body" class="block text-sm font-medium text-gray-700">Улица</label>
            </div>
            <div class="mt-1">
                <input v-model="fields.street" type="text" name="street" id="body"
                          class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                          placeholder=""/>
            </div>
        </div>
        <div class="mt-2">
            <div class="flex justify-between">
                <label for="body" class="block text-sm font-medium text-gray-700">Сайт</label>
            </div>
            <div class="mt-1">
                <input v-model="fields.url" type="text" name="url" id="body"
                       class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                       placeholder=""/>
            </div>
        </div>
        <div class="mt-2">
            <div class="flex justify-between">
                <label for="body" class="block text-sm font-medium text-gray-700">Компания</label>
            </div>
            <div class="mt-1">
                <input v-model="fields.company" type="text" name="company" id="body"
                       class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                       placeholder=""/>
            </div>
        </div>
        <div class="mt-2">
            <div class="flex justify-between">
                <label for="body" class="block text-sm font-medium text-gray-700">Должность</label>
            </div>
            <div class="mt-1">
                <input v-model="fields.role" type="text" name="role" id="body"
                       class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                       placeholder=""/>
            </div>
        </div>
    </div>
</template>

<script>
import {mapActions, mapState} from "pinia";
import {qrCodeFormStore} from "@/scripts/store/qr_code_form.store";

export default {
    props: {
        destinationId: {
            required: true
        }
    },

    computed: {
        ...mapState(qrCodeFormStore, ['code']),
        fields: {
            get() {
                return this.code.destinations[this.destinationId].data
            },
            set(val) {
                this.updateDestinationData(this.destinationId, val)
            }
        }
    },

    methods: {
        ...mapActions(qrCodeFormStore, ['updateDestinationData'])
    }
}
</script>
